/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DistrictInfoCreate } from '../models/DistrictInfoCreate';
import type { DistrictInfoDetails } from '../models/DistrictInfoDetails';
import type { DistrictInfoUpdate } from '../models/DistrictInfoUpdate';
import { request as __request } from '../core/request';

export class DistrictInfoVService {

    /**
     * @param infoId
     * @param districtId
     * @param requestBody
     * @returns DistrictInfoDetails OK
     * @throws ApiError
     */
    public static async districtInfoVUpdateDistrict(
        infoId: string,
        districtId: string,
        requestBody?: DistrictInfoUpdate,
    ): Promise<DistrictInfoDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/districts/${districtId}/info/${infoId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param districtId
     * @returns DistrictInfoDetails OK
     * @throws ApiError
     */
    public static async districtInfoVGetDistrictInfo(
        districtId: string,
    ): Promise<DistrictInfoDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/districts/${districtId}/info`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param districtId
     * @param requestBody
     * @returns DistrictInfoDetails Created
     * @throws ApiError
     */
    public static async districtInfoVCreate(
        districtId: string,
        requestBody?: DistrictInfoCreate,
    ): Promise<DistrictInfoDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/districts/${districtId}/info`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

}